import React, { Component, PropTypes } from 'react'
import withCdnUrl from './withCdnUrl'

export class BiColumn extends Component {
  render() {
    return (
      <section>
        <div className="container">
          <div className="section__head--noPara">
            <h2>Program Benefits</h2>
          </div>
          <div className="section__body">
            <div className="row--thinner">
              <div className="column--half">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/illustrations/pvs-character.gif`} />
                  <div className="meta">
                    <h4>Character Development</h4>
                    <p>
                      Students build character and develop discipline, self-esteem and sportsmanship through
                      practice and gameplay.
                    </p>
                  </div>
                </div>
              </div>
              <div className="column--half">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/illustrations/pvs-stem.gif`} />
                  <div className="meta">
                    <h4>STEM Engagement</h4>
                    <p>
                      Esports players are often interested in STEM classes and programs. A high percentage of
                      collegiate esports players select STEM majors.
                    </p>
                  </div>
                </div>
              </div>
              <div className="column--half">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/illustrations/pvs-scholarships.gif`} />
                  <div className="meta">
                    <h4>College Scholarships</h4>
                    <p>
                      200 colleges and universities offer esports scholarships and are actively recruiting
                      players for their teams.
                    </p>
                  </div>
                </div>
              </div>
              <div className="column--half">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/illustrations/pvs-participation.gif`} />
                  <div className="meta">
                    <h4>Increase Participation</h4>
                    <p>
                      Esports are co-ed and inclusive and engage students who might not otherwise participate
                      in school athletics or activities.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default withCdnUrl(BiColumn)



// WEBPACK FOOTER //
// ./src/common/ui/components/biColumn.js